module.exports = __webpack_public_path__ + "static/media/107-smartphone.7a0a6d3f.svg";